export const listProductLineItems = `
   query listProductLineItems($productId: ID!, $filter: ProductLineItemsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listProductLineItems(productId: $productId, filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              productId
              product {
                id
                name
              }
              productFeatureId
              productFeature {
                id
                name
              }
              position
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProductLineItem = `
   query getProductLineItem($id:ID!) {
       getProductLineItem(id:$id) {
        id
        productId
        productFeature {
            id
            name
        }
        productFeatureId
        product {
            id
            name
        }
        position
        createdByUsername
        created
        updated
       } 
}`;
